/**
 * 첨부 다운로드 URL 의 쿼리 '+' 안전 인코딩 (브라우저 클릭·서버 fetch 공용).
 *   쿼리의 bare '+' 는 base64 file-id 토큰(atchFileId/atchDocId 등)에서 literal '+' 를 잃지 않도록 %2B 로 인코딩.
 *   단 filename/경로 계열 파라미터의 '+' 는 form-encoding 상 '공백'이라 원문 유지(서버가 literal '+' 로 오인 방지).
 *   (크롤러 collectSupportFiles.encodePlusInQuery 와 동일 규칙 — 브라우저 <a href> 클릭 다운로드 깨짐 방지용)
 */
export function encodePlusInQuery(url: string): string {
  const qi = url.indexOf("?");
  if (qi < 0) return url;
  const isFilenameParam = (k: string) => /^(file|filename|file_?nm|fname|org(_?file)?nm|fileName|attachFilePath|file_?[Pp]ath|user_file_nm|sys_file_nm)$/i.test(k);
  const query = url.slice(qi + 1).split("&").map((pair) => {
    const eq = pair.indexOf("=");
    if (eq < 0) return pair.replace(/\+/g, "%2B");
    const key = pair.slice(0, eq);
    const val = pair.slice(eq + 1);
    return key + "=" + (isFilenameParam(key) ? val : val.replace(/\+/g, "%2B"));
  }).join("&");
  return url.slice(0, qi) + "?" + query;
}
